import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './point-allocation.reducer';

export const PointAllocationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pointAllocationEntity = useAppSelector(state => state.pointAllocation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pointAllocationDetailsHeading">
          <Translate contentKey="fivePlusApp.pointAllocation.detail.title">PointAllocation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{pointAllocationEntity.id}</dd>
          <dt>
            <span id="point">
              <Translate contentKey="fivePlusApp.pointAllocation.point">Point</Translate>
            </span>
          </dt>
          <dd>{pointAllocationEntity.point}</dd>
          <dt>
            <span id="pointType">
              <Translate contentKey="fivePlusApp.pointAllocation.pointType">Point Type</Translate>
            </span>
          </dt>
          <dd>{pointAllocationEntity.pointType}</dd>
          <dt>
            <span id="timestamp">
              <Translate contentKey="fivePlusApp.pointAllocation.timestamp">Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {pointAllocationEntity.timestamp ? (
              <TextFormat value={pointAllocationEntity.timestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="sourceId">
              <Translate contentKey="fivePlusApp.pointAllocation.sourceId">Source Id</Translate>
            </span>
          </dt>
          <dd>{pointAllocationEntity.sourceId}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.pointAllocation.user">User</Translate>
          </dt>
          <dd>{pointAllocationEntity.user ? pointAllocationEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/point-allocation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/point-allocation/${pointAllocationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PointAllocationDetail;
